import { Backdrop, makeStyles } from "@material-ui/core";
import React, { useReducer } from "react";
import { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Input,
  FormText,
  FormGroup,
  Label,
  CustomInput,
  Button,
  Alert,
} from "reactstrap";
import { URL } from "../../../config";
import { APIS } from "../../../Constants/endpoints";
import { CONSTANTS } from "../../../Constants/constants";
import { errorToast, successToast } from "../../../Containers/toastFunctions";
import { getToken } from "../../../Functions/userAuth";
import Header from "../../Header";
import { RedemptionReportData } from "./RedemptionReportData";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    overflow: "scroll",
  },

  fileLink: {
    padding: "15px",
    margin: "10px",
    background: "white",
    border: "1px dashed black",
  },
}));

const RedemptionReport = () => {
  const classes = useStyles();
  const reducer = (state, newState) => ({ ...state, ...newState });
  const [redemptionData, setRedemptionData] = useReducer(reducer, {
    startDate: "",
    endDate: "",
    isCSVRequired: true,
  });
  const [data, setData] = useState();
  const [isLoading, setLoading] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);

  const onChange = (e) => {
    let { name, value } = e.target;

    setRedemptionData({ [name]: value });
  };

  const handleBackdropClose = () => {
    setBackdropOpen(false);
  };

  const handleBackdropToggle = () => {
    setBackdropOpen(true);
  };

  const handleReport = (e) => {
    e.preventDefault();
    setLoading(true);
    fetch(
      `${APIS._redemptionReportData}?startDate=${redemptionData.startDate}&endDate=${redemptionData.endDate}&isCSVRequired=${redemptionData.isCSVRequired}&page=1&items=10000`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${getToken("token")}`,
          "Ocp-Apim-Subscription-Key": URL.mzaalo_ocp_key,
        },
      },
    )
      .then((response) => response.json())
      .then(async (res) => {
        setLoading(false);
        console.log("data", res);
        if (res && res.status) {
          let data = res && res.data;
          setData(data);
          successToast(res?.message);
        } else {
          errorToast("Something went wrong");
        }
      })
      .catch((err) => {
        setLoading(false);
        errorToast("Something went wrong!");
      });
  };

  return (
    <div>
      <Header type="mainHeader" headerText="Redemption Report" />
      <div>
        <Form
          onSubmit={handleReport}
          style={{
            border: "1px solid gainsboro",
            borderRadius: "5px",
            padding: "20px",
            margin: "10px",
          }}
        >
          <FormGroup>
            <Label for="startDate">
              Start Date<span className="required">*</span>
            </Label>
            <Input
              type="date"
              name="startDate"
              id="startDate"
              required
              placeholder="Enter Start Date"
              maxlength="25"
              onChange={onChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="endDate">
              End Date<span className="required">*</span>
            </Label>
            <Input
              type="date"
              name="endDate"
              id="endDate"
              required
              placeholder="Enter End Date"
              maxlength="25"
              onChange={onChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="isCSVRequired">
              Is CSV Required?<span className="required">*</span>
            </Label>
            <CustomInput
              type="select"
              name="isCSVRequired"
              id="isCSVRequired"
              required
              placeholder="Select If CSV required"
              onChange={onChange}
            >
              <option value="">Select Option</option>
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </CustomInput>
          </FormGroup>
          <Button color="info">Submit</Button>
        </Form>
      </div>
      {data && (
        <div>
          {data?.fileLink && (
            <div className={classes.fileLink}>
              <a
                href={data?.fileLink?.replace(
                  CONSTANTS.SHAKTI_CLOUD_URL,
                  CONSTANTS.MEDIA_EROS_URL,
                )}
              >
                {data?.fileLink?.replace(
                  CONSTANTS.SHAKTI_CLOUD_URL,
                  CONSTANTS.MEDIA_EROS_URL,
                )}
              </a>
            </div>
          )}

          <div className="cursor-pointer" onClick={handleBackdropToggle}>
            <Button color="success">Click Here to See Table Data </Button>
          </div>
        </div>
      )}
      <Backdrop
        className={`${classes.backdrop} flexbox-center flex-column`}
        open={backdropOpen}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={handleBackdropClose}
        >
          Close
        </Button>
        <RedemptionReportData data={data?.redemptions} />
      </Backdrop>
    </div>
  );
};

export default RedemptionReport;
